<template>
  <div class="input-select weight-select relative d-block clear-float" v-on-clickaway="closeSelect">
    <label @click="closeSelect">{{ label }} <span v-if="rules.required" class="warning-color">*</span></label>
    <div class="input-holder">
      <input
        tabindex="2"
        :class="{required: localShouldShowError}"
        class="input-left"
        :value="value.value"
        @focus="$emit('focus')"
        @input="changeValue($event.target.value)" />
    </div>
    <div
      @click="openListOnClick"
      @focus="openListOnFocus"
      class="input-like absolute">
      <span v-if="value.unit === ''">Select option</span>
      <span v-else class="dark-text">{{ value.unit }}</span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <span v-if="localShouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
    <div v-show="isListOpened" class="options-list">
      <ul>
        <li
          @keydown.prevent="nextItem"
          v-for="(item, index) in getWeightUnitOptions"
          :ref="`${randomSelectId}-${index}-opt`"
          :key="`option-${index}`"
          :class="{active: indexItem === index}"
          @click="changeUnit(item)">
          {{ item.text }}
          <input :value="item.value.unit" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import mixin from '@/mixins/mixins.js';
import rules from "@/mixins/rules";

export default {
  name: 'WeightSelect',
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [mixin, rules],
  props: {
    selectionType: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => {
        return{
          value: '',
          unit: 'kg',
        }
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      weightUnitOptions: []
    };
  },
  computed: {
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    localShouldShowError() {
      return this.externValidate(this.value.value)
    },
    getWeightUnitOptions() {
      if (this.selectionType === 'dangerous_goods') {
        return this.dgUnitsWeightSelection;
      } else if (this.selectionType === 'nem_weight') {
        return this.nemWeightSelection;
      } else {
        return this.unitsWeightSelection;
      }
    }
  },
  methods: {
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.unitsWeightSelection.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    openList() {
      this.isListOpened = true;
      this.unitsWeightSelection.filter((opt, index) => {
        if(opt.value == this.value.unit) this.indexItem = index;
      });
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      });
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.unitsWeightSelection.filter((opt, index) => {
        if(opt.value == this.value.unit) this.indexItem = index;
      });
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.unitsWeightSelection.filter((opt, index) => {
        if(opt.value == this.value.unit) this.indexItem = index;
      });
      this.$nextTick(() => {
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      });
    },
    changeUnit(option) {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.$emit('input', {
        value: this.value.value,
        unit: option.value,
      });
    },
    changeValue(val) {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.$emit('input', {
        value: val,
        unit: this.value.unit,
      });
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
    },
  },
}
</script>
